import { Buildings } from '@phosphor-icons/react';
import { Link } from 'react-router';
import { buttonStyles, cn } from '@skupreme/shared/ui';
import { HeaderText, ShadowBox } from '@elements/Common';
import SecureLayout from '@layouts/SecureLayout';
import { brand } from '@utility/config';

/* The page under the 56px header, behind a dimmed, blurred screenshot. */
export const BLURRED_PAGE = cn(
  'sk:relative sk:flex sk:h-[calc(100vh-56px)] sk:flex-col sk:items-center sk:justify-center sk:overflow-hidden',
  'sk:rounded-[10px] sk:bg-cover sk:bg-no-repeat',
  "sk:before:absolute sk:before:inset-0 sk:before:block sk:before:bg-[rgba(57,57,72,0.3)] sk:before:content-['']",
);

export function UnAuthorized() {
  return (
    <SecureLayout customClass="sk:p-0!">
      <div className={BLURRED_PAGE} style={blurredBackground()}>
        <HeaderText>You do not have permission to access this page.</HeaderText>
      </div>
    </SecureLayout>
  );
}

export function blurredBackground(menu?: string) {
  return {
    backgroundImage: `url('/images/blurring-image/${menu || 'Dashboard'}.png')`,
  };
}

function UpgradePlanBox() {
  return (
    <ShadowBox className="sk:relative sk:z-[1000] sk:flex sk:max-w-[530px] sk:flex-col sk:items-start sk:p-[50px]!">
      <div>
        <Buildings size={40} weight="light" className="sk:text-brand" />
      </div>
      <div>
        <h1 className="sk:mx-auto sk:my-[0.3rem] sk:text-left sk:text-[2.25rem] sk:leading-[1.1] sk:font-bold sk:tracking-[-1.8px] sk:md:text-[2.75rem] sk:lg:text-[3.2rem]">
          Thanks for using {brand.name}
        </h1>
      </div>
      <div className="sk:my-5! sk:flex! sk:flex-col!">
        <span>
          It looks like we need to update your billing information to continue
          providing our services. Keeping your payment details current ensures
          you&apos;ll have uninterrupted access to all the features that help
          scale your business.
        </span>
        <span className="sk:my-5!">
          Your subscription helps us continue to provide powerful tools that
          drive your business growth.
        </span>
        <span>
          Options
          <ul>
            <li>
              Update Payment Method: Add or update your payment information to
              continue your subscription
            </li>
            <li>
              Schedule a Call: Speak with our team about your account or explore
              other plan options
            </li>
            <li>
              Review Subscription: Check your current plan details and billing
              cycle
            </li>
          </ul>
        </span>
        <span>
          We&apos;re here to help if you have any questions about your account
          or subscription.
        </span>
      </div>
      <div className="sk:flex sk:w-full sk:justify-end sk:gap-3">
        <Link
          to="/app/settings/?tab=subscription"
          className={buttonStyles({ variant: 'pill', size: 'lg' })}
        >
          Renew Subscription
        </Link>
        <a
          href="https://skupreme.com/schedule-meeting"
          target="_blank"
          rel="noreferrer"
          className={buttonStyles({
            variant: 'primary',
            size: 'lg',
            className: 'sk:bg-brand sk:text-white sk:hover:bg-brand-hover',
          })}
        >
          Book a Call
        </a>
      </div>
    </ShadowBox>
  );
}

export function UpgradePlanTab() {
  return (
    <div className="sk:flex sk:w-full sk:items-center sk:justify-center sk:pt-[10%]">
      <UpgradePlanBox />
    </div>
  );
}

interface UpgradePlanProps {
  menu?: { key: string };
}

export function UpgradePlan({ menu }: UpgradePlanProps) {
  return (
    <SecureLayout className="sk:p-0!">
      <div className={BLURRED_PAGE} style={blurredBackground(menu?.key)}>
        <UpgradePlanBox />
      </div>
    </SecureLayout>
  );
}
